import { Button } from '../../../components/Button/Button'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export const DeltaTrialHeader: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Button variant='header' className='button-medium px-2 py-1 zocks-ms-2' onClick={() => navigate(-1)}>
      <i className='bi bi-chevron-left' />
      Back
    </Button>
  )
}
